import './Alert.scss';
import Component from './Alert.js';
export default Component;